import { ILoginBody, ILoginRes } from 'src/types/auth.type';
import { IBaseResponse } from 'src/types/common.type';
import http from 'src/utils/http';

export default class AuthService {
  private url = '/api/auth';

  public async login(body: ILoginBody) {
    const { data } = await http.post<ILoginRes>(`${this.url}/login`, body);
    return data;
  }

  public async refresh(body: any) {
    const { data } = await http.post<IBaseResponse<ILoginRes>>(`${this.url}/refresh`, body);
    return data.data;
  }
}
